module.exports = __webpack_public_path__ + "img/260123_EBC_Trading_Academy_Banner_01_SC_686x280_Final.f4e1f05a.gif";